import type { ContactsApi } from '@izimi/api';
import type { FirstParameter } from '@izimi/utils';

export type ContactsQueryKeyType = 'contactRequests' | 'contactList' | 'vaultTransfer';

class ContactsQueryKeys {
  constructor(private prefix: string) {}

  getContacts(type: ContactsQueryKeyType, params?: FirstParameter<ContactsApi['getContactsV2']>) {
    if (params) {
      return [this.prefix, type, params];
    }
    return [this.prefix, type];
  }
}

export default ContactsQueryKeys;
